import * as charitySettings from "../../lib/api/charitySettings"
// import * as posCharityMode from "../../enums/posCharityMode"
import AlertModal from "../AlertModal";
import ImageSetUploader from "../ImageSetUploader";
import Loader from "../Loader";
import logger from "../../lib/logger";
import React, { PureComponent } from "react";
// import StyledDropdown from "../StyledDropdown";
import { StyleSheet, css } from "aphrodite";
import { Button, Checkbox, ControlLabel, Grid, Form, FormControl, FormGroup, Row, Col } from "react-bootstrap";

const styles = StyleSheet.create({
    loadingContainer: {
        position: "absolute",
        top: "50px",
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        display: "flex",
        alignItems: "center",
    },
    verticalSpacing: {
        marginBottom: 25,
    },
    horizontalPadding: {
        paddingLeft: 15,
    },
    saveSettingsButton: {
        width: "100%",
    },
    uploadImageForm: {
        marginTop: 0,
        marginBottom: 25,
    },
    topSpacing: {
        marginTop: 25,
    },
    dollarsInput: {
        paddingLeft: 20,
    },
    dollarSign: {
        position: "absolute",
        left: 40,
        marginBottom: 0,
    },
    dollarInput: {
        display: "flex",
        alignItems: "center",
    }
})

const strings = {
    documentTitle: "Charity Settings | Habit CMS",
    pageTitle: "Charity Settings",
    digitalSubtitle: "Digital (web, mobile app, kiosk)",
    saveDigital: "Save Digital",
    webEnabledLabel: "Web Enabled",
    mobileEnabledLabel: "Mobile/Kiosk Enabled",
    charityNameLabel: "Charity Name",
    donationCodeLabel: "Charity Code (Sent to Tracks for accounting purposes)",
    logoLabel: "Logo",
    charityInfoLabel: "Charity Info Pop-up Text",
    posSubtitle: "POS",
    savePos: "Save POS",
    posEnabledLabel: "Enabled",
    cashierPromptLabel: "Cashier Prompt",
    roundUpModeLabel: "Round up Mode",
    rewardEnabledLabel: "Reward Enabled",
    rewardMinimumLabel: "Reward Minimum",
    rewardMessageLabel: "Reward Message",
    updateDigitalSuccessful: "The Digital Charity Settings have been successfully updated.",
    updatePosSuccessful: "The Pos Charity Settings have been successfuly updated.",
    failedToUpdateDigital: "There was an error while updating the Digital Charity Settings. No changes were made.",
    failedToUpdatePos: "There was an error while updating the Pos Charity Settings. No changes were made.",
    charityCodeMustBePositiveInt: "Charity code must be a positive integer. No changes were made.",
    rewardMinimumMustBePositive: "Reward minimum must be a positive amount. No changes were made.",
    failedToLoadDigital: "Failed to load digital charity settings.",
    failedToLoadPos: "Failed to load POS Charity settings.",
    dollarSign: "$",
}

const noOptionValue = -1

class CharitySettingsPage extends PureComponent {
    state = {
        settings: null,
        webEnabled: false,
        mobileEnabled: false,
        charityName: "",
        donationCode: "",
        image: null,
        additionalInfo: "",
        posEnabled: false,
        cashierPrompt: "",
        mode: "",
        rewardEnabled: false,
        rewardMinimumDollars: "",
        rewardMessage: "",
        isLoading: false,
        showAlertModal: false,
        alertMsg: "",
    }

    componentDidMount() {
        document.title = strings.documentTitle;
        this._loadDigitalSettings();
        this._loadPosSettings();
    }

    _handleError = (e, defaultAlertMsg) => {
        logger.warn(e);
        let alertMsg = defaultAlertMsg;
        if (
            e &&
            e.response &&
            e.response.status === 400 &&
            e.response.data &&
            typeof e.response.data === "string"
        ) {
            alertMsg = e.response.data;
        }
        this.setState({ isLoading: false, showAlertModal: true, alertMsg });
    }

    _loadDigitalSettings = () => {
        this.setState({ isLoading: true });

        charitySettings
            .getCurrentDigitalCharitySettings()
            .then(resp => {
                let additionalInfo = "";
                if (resp.additionalInfo !== null) {
                    additionalInfo = resp.additionalInfo;
                }
                let images = null;
                if (resp.logoImages !== null) {
                    images = resp.logoImages;
                }
                this.setState({
                    settings: {
                        ...this.state.settings,
                        webEnabled: resp.webEnabled,
                        mobileEnabled: resp.mobileEnabled,
                        charityName: resp.charityName,
                        donationCode: resp.donationCode,
                        additionalInfo: additionalInfo,
                        images: images,
                    },
                    webEnabled: resp.webEnabled,
                    mobileEnabled: resp.mobileEnabled,
                    charityName: resp.charityName,
                    donationCode: resp.donationCode.toString(),
                    additionalInfo: additionalInfo,
                    isLoading: false,
                });
            })
            .catch(e => {
                this._handleError(e, strings.failedToLoadDigital);
            });
    }

    _loadPosSettings = () => {
        this.setState({ isLoading: true });

        charitySettings
            .getCurrentPosCharitySettings()
            .then(resp => {
                let cashierPrompt = "";
                if (resp.cashierPrompt !== null) {
                    cashierPrompt = resp.cashierPrompt;
                }
                let rewardMinimumCents = noOptionValue;
                let rewardMinimumDollars = "";
                let rewardEnabled = true;
                let rewardMessage = "";
                if (resp.rewardMessage !== null) {
                    rewardMessage = resp.rewardMessage;
                }
                if (resp.rewardMinimumCents !== null) {
                    rewardMinimumCents = resp.rewardMinimumCents;
                    rewardMinimumDollars = (rewardMinimumCents / 100).toString();
                } else {
                    rewardEnabled = false;
                    rewardMinimumDollars = "0";
                    rewardMessage = "";
                }
                this.setState({
                    settings: {
                        ...this.state.settings,
                        posEnabled: resp.enabled,
                        cashierPrompt: cashierPrompt,
                        mode: resp.mode,
                        rewardMinimumCents: rewardMinimumCents,
                        rewardMessage: rewardMessage,
                        rewardEnabled: rewardEnabled,
                    },
                    posEnabled: resp.enabled,
                    cashierPrompt: cashierPrompt,
                    mode: resp.mode,
                    rewardMinimumDollars: rewardMinimumDollars,
                    rewardMessage: rewardMessage,
                    isLoading: false,
                    rewardEnabled: rewardEnabled,
                });
            })
            .catch(e => {
                this._handleError(e, strings.failedToLoadPos)
            });
    }

    _onWebEnabledChange = () => {
        this.setState((prev) => ({ webEnabled: !prev.webEnabled }))
    }

    _onMobileEnabledChange = () => {
        this.setState((prev) => ({ mobileEnabled: !prev.mobileEnabled }))
    }

    _onCharityNameChange = e => {
        e.preventDefault();
        this.setState({ charityName: e.target.value })
    }

    _onDonationCodeChange = e => {
        e.preventDefault();
        this.setState({ donationCode: e.target.value })
    }

    _onAdditionalInfoChange = e => {
        e.preventDefault();
        this.setState({ additionalInfo: e.target.value })
    }

    _onPosEnabledChange = () => {
        this.setState((prev) => ({ posEnabled: !prev.posEnabled }))
    }

    _onCashierPromptChange = e => {
        e.preventDefault();
        this.setState({ cashierPrompt: e.target.value })
    }

    _onModeChange = value => {
        this.setState({ mode: value });
    };

    _onRewardEnabledChanged = () => {
        this.setState((prev) => ({ rewardEnabled: !prev.rewardEnabled }))
    }
    
    _onRewardMinimumChange = e => {
        e.preventDefault();
        this.setState({ rewardMinimumDollars: e.target.value })
    }

    _onRewardMessageChange = e => {
        e.preventDefault();
        this.setState({ rewardMessage: e.target.value })
    }

    _handleLogoImageOnSubmit = (image, crop, imageData) => {
        this.setState({
            image: {
                image,
                centerX: crop.x,
                centerY: crop.y,
                width: crop.width,
                height: crop.height,
                imageData: imageData,
            },
        });
    };

    _handleUpdateDigitalSettings = (e) => {
        e.preventDefault();
        this.setState({ isLoading: true })
        const donationCode = parseFloat(this.state.donationCode);
        if (isNaN(donationCode) || !Number.isInteger(donationCode) || donationCode < 0) {
            this.setState({
                isLoading: false,
                showAlertModal: true,
                alertMsg: strings.charityCodeMustBePositiveInt
            })
            return;
        }
        const donationCodeInt = parseInt(donationCode);
        const charityNameTrim = this.state.charityName.trim();
        const additionalInfoTrim = this.state.additionalInfo.trim();
        const settings = this.state.settings;
        charitySettings
            .updateDigitalCharitySettings(
                settings && charityNameTrim !== settings.charityName ? charityNameTrim : null,
                settings && donationCodeInt !== settings.donationCode ? donationCodeInt : null,
                settings && additionalInfoTrim !== settings.additionalInfo ? additionalInfoTrim : null,
                this.state.image,
                settings && this.state.webEnabled !== settings.webEnabled ? this.state.webEnabled : null,
                settings && this.state.mobileEnabled !== settings.mobileEnabled ? this.state.mobileEnabled : null,
            )
            .then(() => {
                this._loadDigitalSettings();
                this.setState({ showAlertModal: true, alertMsg: strings.updateDigitalSuccessful })
            })
            .catch(err => {
                this._handleError(err, strings.failedToUpdateDigital)
            })
    }

    _handleUpdatePosSettings = (e) => {
        e.preventDefault();
        this.setState({ isLoading: true })
        const rewardMinimum = parseFloat(this.state.rewardMinimumDollars);
        if (isNaN(rewardMinimum) || rewardMinimum < 0) {
            this.setState({
                isLoading: false,
                showAlertModal: true,
                alertMsg: strings.rewardMinimumMustBePositive
            })
            return;
        }
        const rewardMinimumCents = Math.round(rewardMinimum * 100);
        const cashierPromptTrim = this.state.cashierPrompt.trim();
        const rewardMessageTrim = this.state.rewardMessage.trim();
        const settings = this.state.settings;
        charitySettings
            .updatePosCharitySettings(
                settings && this.state.posEnabled !== settings.posEnabled ? this.state.posEnabled : null,
                settings && cashierPromptTrim !== settings.cashierPrompt ? cashierPromptTrim : null,
                null,
                // settings && this.state.mode !== settings.mode ? this.state.mode : null,
                this.state.rewardEnabled ? rewardMinimumCents : null,
                this.state.rewardEnabled && settings && rewardMessageTrim !== settings.rewardMessage ? rewardMessageTrim : null,
            )
            .then(() => {
                this._loadPosSettings();
                this.setState({ showAlertModal: true, alertMsg: strings.updatePosSuccessful })
            })
            .catch(err => {
                this._handleError(err, strings.failedToUpdatePos)
            })
    }

    _hideAlertModal = () => {
        this.setState({ showAlertModal: false });
    };

    render() {
        const settings = this.state.settings;

        const isDigitalValid = 
            !!this.state.charityName.trim() &&
            !!this.state.donationCode.trim() &&
            !!this.state.additionalInfo.trim()

        const isDigitalChanged =
            !!settings &&
            (
                settings.charityName !== this.state.charityName.trim() ||
                settings.donationCode.toString() !== this.state.donationCode.trim() ||
                settings.additionalInfo !== this.state.additionalInfo.trim() ||
                this.state.image ||
                settings.webEnabled !== this.state.webEnabled ||
                settings.mobileEnabled !== this.state.mobileEnabled
            )

        const isPosValid =
            (!this.state.rewardEnabled || (
                !!this.state.rewardMinimumDollars.trim() &&
                this.state.rewardMessage.trim()
            ))

        const isPosChanged = 
            !!settings &&
            (
                settings.posEnabled !== this.state.posEnabled ||
                settings.cashierPrompt !== this.state.cashierPrompt.trim() ||
                settings.mode !== this.state.mode ||
                settings.rewardEnabled !== this.state.rewardEnabled ||
                settings.rewardEnabled && (settings.rewardMinimumCents / 100).toString() !== this.state.rewardMinimumDollars.trim() ||
                settings.rewardEnabled && settings.rewardMessage !== this.state.rewardMessage.trim()
            )
        

        const isSaveDigitalEnabled = !this.state.isLoading && isDigitalValid && isDigitalChanged

        const isSavePosEnabled = !this.state.isLoading && isPosValid && isPosChanged

        return (
            <Grid>
                <Row>
                    <Col md={6}>
                        <h3 className={css(styles.verticalSpacing)}>
                            {strings.pageTitle}
                        </h3>
                    </Col>
                </Row>
                <Form onSubmit={this._handleUpdateDigitalSettings}>
                    <Row>
                        <Col md={8}>
                            <h4 className={css(styles.verticalSpacing, styles.horizontalPadding)}>
                                {strings.digitalSubtitle}
                            </h4>
                        </Col>
                        <Col md={2}>
                            <Button
                                type="submit"
                                bsStyle="primary"
                                className={css(styles.saveSettingsButton, styles.verticalSpacing)}
                                disabled={!isSaveDigitalEnabled}
                            >
                                {strings.saveDigital}
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup controlId="webEnabled" className={css(styles.verticalSpacing, styles.horizontalPadding)}>
                                <Checkbox
                                    id="webEnabled"
                                    checked={this.state.webEnabled}
                                    onChange={this._onWebEnabledChange}
                                >
                                    {strings.webEnabledLabel}
                                </Checkbox>
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup controlId="mobileEnabled" className={css(styles.verticalSpacing, styles.horizontalPadding)}>
                                <Checkbox
                                    id="mobileEnabled"
                                    checked={this.state.mobileEnabled}
                                    onChange={this._onMobileEnabledChange}
                                >
                                    {strings.mobileEnabledLabel}
                                </Checkbox>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup controlId="charityName" className={css(styles.verticalSpacing, styles.horizontalPadding)}>
                                <ControlLabel>{strings.charityNameLabel}</ControlLabel>
                                <FormControl
                                    id="charityName"
                                    type="text"
                                    value={this.state.charityName}
                                    onChange={this._onCharityNameChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup controlId="donationCode" className={css(styles.verticalSpacing, styles.horizontalPadding)}>
                                <ControlLabel>{strings.donationCodeLabel}</ControlLabel>
                                <FormControl
                                    id="donationCode"
                                    type="number"
                                    min="0"
                                    value={this.state.donationCode}
                                    onChange={this._onDonationCodeChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5}>
                            <FormGroup controlId="additionalInfo" className={css(styles.verticalSpacing, styles.horizontalPadding)}>
                                <ControlLabel>{strings.charityInfoLabel}</ControlLabel>
                                <FormControl
                                    id="additionalInfo"
                                    componentClass="textarea"
                                    value={this.state.additionalInfo}
                                    onChange={this._onAdditionalInfoChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                                <ImageSetUploader
                                    className={styles.uploadImageForm}
                                    label={strings.logoLabel}
                                    images={!settings || this.state.image ? null : settings.images}
                                    previewImage={this.state.image ? this.state.image.imageData : null}
                                    onSubmit={(image, crop, imageData) =>
                                        this._handleLogoImageOnSubmit(
                                            image,
                                            crop,
                                            imageData,
                                        )
                                    }
                                    minWidth={150}
                                    minHeight={54}
                                />
                        </Col>
                    </Row>
                </Form>

                <Form onSubmit={this._handleUpdatePosSettings}>
                    <Row>
                        <Col md={8}>
                            <h4 className={css(styles.verticalSpacing, styles.horizontalPadding)}>
                                {strings.posSubtitle}
                            </h4>
                        </Col>
                        <Col md={2}>
                            <Button
                                type="submit"
                                bsStyle="primary"
                                className={css(styles.saveSettingsButton, styles.verticalSpacing)}
                                disabled={!isSavePosEnabled}
                            >
                                {strings.savePos}
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={2}>
                            <FormGroup controlId="posEnabled" className={css(styles.verticalSpacing, styles.horizontalPadding, styles.topSpacing)}>
                                <Checkbox
                                    id="posEnabled"
                                    checked={this.state.posEnabled}
                                    onChange={this._onPosEnabledChange}
                                >
                                    {strings.posEnabledLabel}
                                </Checkbox>
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup controlId="cashierPrompt" className={css(styles.verticalSpacing, styles.horizontalPadding)}>
                                <ControlLabel>{strings.cashierPromptLabel}</ControlLabel>
                                <FormControl
                                    id="cashierPrompt"
                                    componentClass="textarea"
                                    value={this.state.cashierPrompt}
                                    onChange={this._onCashierPromptChange}
                                />
                            </FormGroup>
                        </Col>
                        {/* <Col md={3}>
                            <FormGroup
                                    controlId="roundUpMode"
                                    className={css(styles.verticalSpacing, styles.horizontalPadding)}
                            >
                                <ControlLabel>{strings.roundUpModeLabel}</ControlLabel>
                                <StyledDropdown
                                    id="roundUpMode"
                                    placeholder={posCharityMode.roundUpOnly.value}
                                    value={this.state.mode}
                                    onChange={this._onModeChange}
                                    options={[
                                        posCharityMode.roundUpOnly,
                                        posCharityMode.roundUpAndDollars,
                                        posCharityMode.dollarsOnly
                                    ]}
                                />
                            </FormGroup>
                        </Col> */}
                    </Row>
                    <Row>
                        <Col md={2}>
                            <FormGroup controlId="rewardEnabled" className={css(styles.verticalSpacing, styles.horizontalPadding, styles.topSpacing)}>
                                <Checkbox
                                    id="rewardEnabled"
                                    checked={this.state.rewardEnabled}
                                    onChange={this._onRewardEnabledChanged}
                                >
                                    {strings.rewardEnabledLabel}
                                </Checkbox>
                            </FormGroup>
                        </Col>
                        {this.state.rewardEnabled && 
                            <>
                                <Col md={2}>
                                    <FormGroup controlId="rewardMinimum" className={css(styles.horizontalPadding)}>
                                        <ControlLabel>{strings.rewardMinimumLabel}</ControlLabel>
                                        <div className={css(styles.dollarInput)}>
                                            <ControlLabel className={css(styles.dollarSign)}>{strings.dollarSign}</ControlLabel>
                                            <FormControl
                                                id="rewardMinimum"
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                className={css(styles.dollarsInput)}
                                                value={this.state.rewardMinimumDollars}
                                                onChange={this._onRewardMinimumChange}
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md={5}>
                                    <FormGroup controlId="rewardMessage" className={css(styles.verticalSpacing, styles.horizontalPadding)}>
                                        <ControlLabel>{strings.rewardMessageLabel}</ControlLabel>
                                        <FormControl
                                            id="rewardMessage"
                                            componentClass="textarea"
                                            value={this.state.rewardMessage}
                                            onChange={this._onRewardMessageChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </>
                        }
                    </Row>
                </Form>
                <AlertModal
                    show={this.state.showAlertModal}
                    alertMessage={this.state.alertMsg}
                    handleClose={this._hideAlertModal}
                />
                {this.state.isLoading ? (
                    <div className={css(styles.loadingContainer)}>
                        <Loader />
                    </div>
                ) : null}
            </Grid>
        )
    }
}

export default CharitySettingsPage